import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

export const actions = css`
  display: flex;
  border-top: 1px solid ${colors.shadows.getShadow(colors.white, 0.2)};
  padding-top: 10px;
`;

export const link = css`
  width: 100%;
  color: unset;
  text-decoration: none;
`;

export const version = css`
  color: ${colors.gray.light};
  font-size: ${fonts.size.tiny};
  text-align: left;
  margin-left: 20px;
  margin-bottom: 10px;
`;
